import { jsx as _jsx } from "react/jsx-runtime";
import { isConsentManaged, openCookieSettings } from '@/lib/consent/cookieYes';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
/**
 * "Cookie settings": reopens the consent preference centre so a visitor can change or withdraw
 * their choice as easily as they gave it. Renders nothing where consent is not managed.
 */
export function CookieSettingsButton({ className }) {
    const { t } = useTranslation();
    if (!isConsentManaged())
        return null;
    return (_jsx("button", { type: "button", onClick: openCookieSettings, className: cn('hover:underline', className), "data-testid": "cookie-settings", children: t('legal.cookieSettings') }));
}
